import React, {useEffect, useState, forwardRef} from 'react';
import {Input, InputRef} from 'antd';

// Используем forwardRef для передачи ref
interface NumericInputProps {
    onClear?: any,
    style?: React.CSSProperties,
    value?: string,
    onChange: (value: number) => void,
    maxLength?: number,
    placeholder?: string,
    allowClear?: boolean,
    selectAfter?: any
}

// Оборачиваем компонент в forwardRef
const NumericInput = forwardRef<InputRef, NumericInputProps>(
    ({
         onClear,
         style,
         value,
         onChange,
         maxLength,
         placeholder,
         allowClear,
         selectAfter},
     ref) => {

        const [inputValue, setInputValue] = useState<string>('0');

        useEffect(() => {
            setInputValue(value || '0');
        }, [value]);

        const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault(); // Предотвращаем стандартное поведение
            const pastedValue = e.clipboardData.getData('Text').replace(/[^0-9]/g, '');
            updateValue(pastedValue);
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            let newValue = e.target.value.replace(/[^0-9.]/g, '');
            const firstDotIndex = newValue.indexOf('.');
            if (firstDotIndex !== -1) {
                // Убираем все точки после первой
                newValue =
                    newValue.slice(0, firstDotIndex + 1) +
                    newValue.slice(firstDotIndex + 1).replace(/\./g, '');
            }
            updateValue(newValue);
        };


        const updateValue = (newValue: string) => {
            const truncatedValue = newValue.substring(0, maxLength);
           // onChange(Number(truncatedValue));
            setInputValue(truncatedValue);
        };

        const handleBlur = () => {
            let valueTemp = String(inputValue);
            if (valueTemp) {
                if (valueTemp === '-') {
                    valueTemp = inputValue.slice(0, -1);
                }
                onChange(Number(valueTemp));
            }
            if (valueTemp === '') {
                setInputValue('0');
            }
        };

        const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
            if (Number(e.currentTarget.value) === 0) {
                setInputValue('');
            }
        };

        return (
            <Input
                allowClear={allowClear}
                ref={ref}
                style={style}
                value={inputValue}
                onClick={handleClick}
                onChange={handleChange}
                onPaste={handlePaste}
                onBlur={handleBlur}
                placeholder={placeholder}
                onClear={onClear}
                maxLength={maxLength}
                addonAfter={selectAfter}
            />
        );
    }
);

export default NumericInput;
